import React from 'react';
import { CheckCircle } from 'lucide-react';

const cases = [
  {
    name: 'Pedro Lopes',
    creci: 'CRECI 123456-MT',
    city: 'Sinop - MT',
    specialization: 'Alto Padrão Residencial',
    photo: '/imagens/corretor-pedro.jpg',
    type: 'Volume de Vendas Anual: R$15M',
    tradicional: [
      { label: 'Corretor', value: 'R$337.500 (R$28.125/mês)' },
      { label: 'Imobiliária', value: 'R$300.000 (R$25.000/mês)' },
    ],
    elion: [
      {
        label: 'Se você vender imóveis captados por você:',
        percent: '100% da comissão',
        value: 'R$750.000 (R$62.500/mês)',
      },
      {
        label: 'Se você vender imóveis de seus sócios:',
        percent: '80% da comissão',
        value: 'R$600.000 (R$50.000/mês)',
      },
      {
        label: 'Se você vender imóveis das suas conexões:',
        percent: '50% da comissão',
        value: 'R$375.000 (R$31.250/mês)',
      },
    ],
  },
  {
    name: 'Fernanda Freitas',
    creci: 'CRECI 234567-MT',
    city: 'Sorriso - MT',
    specialization: 'Empreendimentos Verticais',
    photo: '/imagens/corretor-fernanda.jpg',
    type: 'Volume de Vendas Anual: R$10M',
    tradicional: [
      { label: 'Corretor', value: 'R$200.000 (R$16.666/mês)' },
      { label: 'Imobiliária', value: 'R$200.000 (R$16.666/mês)' },
    ],
    elion: [
      {
        label: 'Se você vender imóveis captados por você:',
        percent: '100% da comissão',
        value: 'R$400.000 (R$33.333/mês)',
      },
      {
        label: 'Se você vender imóveis de seus sócios:',
        percent: '80% da comissão',
        value: 'R$320.000 (R$26.666/mês)',
      },
      {
        label: 'Se você vender imóveis das suas conexões:',
        percent: '50% da comissão',
        value: 'R$200.000 (R$16.666/mês)',
      },
    ],
  },
  {
    name: 'Raffael Lavezo',
    creci: 'CRECI 345678-MT',
    city: 'Sinop - MT',
    specialization: 'Lançamentos e Investimentos',
    photo: '/imagens/corretor-raffael.jpg',
    type: 'Volume de Vendas Anual: R$6M',
    tradicional: [
      { label: 'Corretor', value: 'R$120.000 (R$10.000/mês)' },
      { label: 'Imobiliária', value: 'R$120.000 (R$10.000/mês)' },
    ],
    elion: [
      {
        label: 'Se você vender imóveis captados por você:',
        percent: '100% da comissão',
        value: 'R$240.000 (R$20.000/mês)',
      },
      {
        label: 'Se você vender imóveis de seus sócios:',
        percent: '80% da comissão',
        value: 'R$192.000 (R$16.000/mês)',
      },
      {
        label: 'Se você vender imóveis das suas conexões:',
        percent: '50% da comissão',
        value: 'R$120.000 (R$10.000/mês)',
      },
    ],
  },
];

const EarningsComparisonSection = () => {
  return (
    <section className="w-full bg-slate-900 py-16 text-white">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">
        💸 Comparativo de Ganhos Reais
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-7xl mx-auto px-4">
        {cases.map((c, idx) => (
          <div
            key={idx}
            className="bg-slate-800 p-4 rounded-xl shadow-lg flex flex-col justify-between border border-yellow-500/30 hover:shadow-2xl transition"
          >
            <div className="flex items-center gap-3 mb-3">
              <img
                src={c.photo}
                alt={c.name}
                className="w-12 h-12 rounded-full object-cover border border-yellow-500"
              />
              <div>
                <h3 className="text-base font-semibold text-yellow-400">
                  {c.name}
                </h3>
                <p className="text-xs text-gray-300">{c.creci}</p>
                <p className="text-xs text-gray-400">{c.city}</p>
                <p className="text-xs text-gray-400">{c.specialization}</p>
              </div>
            </div>

            <p className="text-xs mb-3 text-gray-300">{c.type}</p>

            <div className="mb-3">
              <h4 className="text-sm font-semibold text-green-400 mb-1">
                Modelo Tradicional
              </h4>
              <ul className="space-y-0.5">
                {c.tradicional.map((item, i) => (
                  <li
                    key={i}
                    className="flex justify-between border-b border-gray-700 py-0.5 text-xs"
                  >
                    <span>{item.label}</span>
                    <span>{item.value}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-slate-700 p-2 rounded-lg mt-3">
              <h4 className="text-sm font-semibold text-green-400 mb-1">
                Elion
              </h4>
              <ul className="space-y-2">
                {c.elion.map((item, i) => (
                  <li
                    key={i}
                    className="flex flex-col border-b border-gray-600 pb-2"
                  >
                    <div className="flex items-center gap-1 text-xs">
                      <CheckCircle size={14} className="text-green-400" />
                      <span className="text-gray-300">{item.label}</span>
                    </div>
                    <div className="mt-0.5 ml-5">
                      <span className="text-green-400 font-medium">
                        {item.percent}
                      </span>{' '}
                      <span className="font-bold text-base text-yellow-400 block">
                        {item.value}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-3 text-center">
              <span className="inline-block bg-green-600 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                Até 2x mais ganhos que o modelo tradicional
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 text-center">
        <p className="text-lg md:text-xl font-medium text-white max-w-3xl mx-auto leading-relaxed">
          Mais que uma plataforma, a{' '}
          <span className="font-bold text-yellow-400">Elion</span> é a
          oportunidade de viver da sua profissão com{' '}
          <span className="font-bold">liberdade</span>,{' '}
          <span className="font-bold">reconhecimento</span> e{' '}
          <span className="font-bold">ganhos justos</span>.
        </p>
      </div>
    </section>
  );
};

export default EarningsComparisonSection;
